module.exports = __webpack_public_path__ + "media/images/sp/reports/mv_copy-a9fe3964a7ba1fa8d7cef643128f07f5.png";